'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = undefined;

var _hasInstance = require('babel-runtime/core-js/symbol/has-instance');

var _hasInstance2 = _interopRequireDefault(_hasInstance);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

var _ownKeys = require('babel-runtime/core-js/reflect/own-keys');

var _ownKeys2 = _interopRequireDefault(_ownKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://raganwald.com/2015/06/26/decorators-in-es7.html
function mixin(behaviour) {
  var sharedBehaviour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var instanceKeys = (0, _ownKeys2.default)(behaviour);
  var sharedKeys = (0, _ownKeys2.default)(sharedBehaviour);
  var typeTag = (0, _symbol2.default)('isa');

  function _mixin(clazz) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(instanceKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var property = _step.value;

        if (except.indexOf(property) > -1) {
          continue;
        }
        (0, _defineProperty2.default)(clazz.prototype, property, {
          value: behaviour[property],
          writable: true
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    (0, _defineProperty2.default)(clazz.prototype, typeTag, { value: true });
    return clazz;
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(sharedKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var property = _step2.value;

      (0, _defineProperty2.default)(_mixin, property, {
        value: sharedBehaviour[property],
        enumerable: sharedBehaviour.propertyIsEnumerable(property)
      });
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  (0, _defineProperty2.default)(_mixin, _hasInstance2.default, {
    value: function value(it) {
      return !!it[typeTag];
    }
  });
  return _mixin;
}

var container = function containerMixin() {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return mixin({
    openModal: function openModal(selectedItem) {
      if (this.canOpenModal(selectedItem)) {
        var _props = this.props,
            push = _props.push,
            queryParams = _props.queryParams; // eslint-disable-line no-shadow

        push({ pathname: '/' + this.props.entity + '/' + (selectedItem.id || 'new'), query: queryParams });
      }
    },
    closeModal: function closeModal() {
      var _props2 = this.props,
          push = _props2.push,
          queryParams = _props2.queryParams; // eslint-disable-line no-shadow

      push({ pathname: '/' + this.props.entity, query: queryParams });
    },
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
      var newId = newProps.params.id;
      var currentId = this.props.params.id;

      var id = parseInt(newId, 10);

      if (this.onComponentWillReceiveProps) {
        this.onComponentWillReceiveProps(newProps);
      }

      if (newId !== currentId) {
        this.setState({
          isModalOpen: !!newId
        });

        if (id && !isNaN(id)) {
          this.setState({
            selectedEditItem: {
              id: id
            }
          });
        } else {
          this.setState({
            selectedEditItem: {}
          });
        }
      }
    },
    onMount: function onMount() {
      var itemId = this.props.params.id;

      var id = parseInt(itemId, 10);

      if (this.beforeOnMount) {
        this.beforeOnMount();
      }

      if (itemId === 'new') {
        this.setState({
          isModalOpen: true,
          selectedEditItem: {}
        });
      } else if (id && !isNaN(id)) {
        this.setState({
          isModalOpen: true,
          selectedEditItem: {
            id: id
          }
        });
      } else {
        this.setState({
          selectedEditItem: {}
        });
      }
    },
    componentDidMount: function componentDidMount() {
      this.onMount();
    },

    state: {
      isModalOpen: false,
      selectedEditItem: {}
    }
  }, {}, except);
};

exports.container = container;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/decorate.js
// module id = 261
// module chunks = 0